module.exports = __webpack_public_path__ + "static/img/kid-4.3bb7683.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kid-4.png
// module id = UObH
// module chunks = 0